/*eslint-disable no-undef*/

__webpack_public_path__ = window.remoteUrl;

const { dispatchEvent } = require('src/frontend/helper/event');

require('./helper/general/m_googleTagManager');

require('./old/common/underscore_mixins');
window.Hogan = require('hogan.js/lib/hogan');
require('./old/groupon_modules/groupon');
require('./old/groupon_modules/performance');

require('./lazyload/lazyLoadImages');
const LSTouch = require('modules/gig_body/header/frontend/views/ls_touch');
require('modules/gig_body/components/back2top/frontend/main');
const {
  init: initDoubleClick,
} = require('modules/doubleclick/frontend/doubleclick');
const verifyUserCookies = require('src/frontend/helper/general/m_verifyUserCookies');
const { User } = require('modules/gig_body/header/usernav/frontend/setup_user');
const uncommentThirdPartyAssets = require('./old/groupon_modules/uncommentThirdPartyAssets');
const { incognitoTest } = require('./helper/incognito');
const {
  initCllTimer,
} = require('./helper/search/helper/m_detectCurrentLocation');
const {
  setELLFromSearchLoc,
} = require('./helper/search/helper/m_location_helper');

const {
  gdprCookieBanner,
} = require('modules/cookie_banner_gdpr/frontend/main');

const { parsed, loaded } = require('./core/browser_events');
const { default: preactClient } = require('app/desktop/client');

incognitoTest('desktop');

setELLFromSearchLoc(); // set ELL from searchLoc cookie

const isSearchHeader = document.head.dataset.header === 'default';

let loadPreactSearch = false;

window.Finch.experiment('LS-4927-Preact-Search-Desktop', {
  Treatment: () => {
    loadPreactSearch = true;
  },
});

parsed.then(() => {
  document.body.classList.remove('no-js');
  gdprCookieBanner();

  preactClient(loadPreactSearch);

  if (isSearchHeader) {
    if (!loadPreactSearch) {
      import(/* webpackChunkName: "desktop-legacy-search" */ 'modules/gig_body/header/search_bar/frontend/desktop_searchbar').then(
        SearchBar => {
          SearchBar.init();
          dispatchEvent('loaded-search-legacy');
        }
      );
    }

    import(/* webpackChunkName: "desktop-common" */ 'modules/gig_body/header/frontend/views/pn_header_v2').then(
      module => {
        const PNHeaderV2 = module.default;
        new PNHeaderV2();
      }
    );
    // Kick off flyout handlers (no-op when element doesn't exist)
  }

  Groupon.Utils.lazyLoadImages();

  // When < 600px (mobile), change the viewport meta tag to disable user scaling.
  // This prevents unnecessary zooming when focusing on inputs and is an alternative to
  // setting the font size of the inputs to 16px (which Apple recommends for iOS Safari).
  const { mMax } = Groupon.LS.mediaQueries;
  if (Groupon.LS.hasTouch && matchMedia(mMax).matches) {
    document.head
      .querySelector('meta[name=viewport]')
      .setAttribute(
        'content',
        'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0'
      );
  }

  Groupon.Utils.lazyLoadImages();
  LSTouch.init();

  // Add handler for back link on responsive header
  $('a.t-back-link')
    .not('[href]')
    .on('click', () => history.back());

  $('#subscribe_modal_container').trigger('launchSubsUIModal');
});

loaded.then(() => {
  User.init();
  setTimeout(() => {
    initCllTimer();

    Groupon.Utils.lazyLoadImages({ threshold: 200 }, '.lazy-wl');
    new Groupon.Widgets.BackToTopButton();

    verifyUserCookies();

    uncommentThirdPartyAssets();

    initDoubleClick();
  }, 0);
});
